import React from 'react'
import styles from './styles'

import { withStyles } from '@material-ui/core/styles'
import { Typography, Box, Divider, Card } from '@material-ui/core'
import Lottie from 'react-lottie'

import animationData from 'src/lotties/AI-ready-v2_small.json'
import { track } from '@amplitude/analytics-browser'
import animationDataMobile from 'src/lotties/AI-ready-v2-mobile_small.json'
import animationDataMobile2 from 'src/lotties/ai-ready-drag-drop-v4.json'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import { CoreButton } from 'src/components/core'
import { useHistory, useLocation } from 'react-router-dom'
import { useCoursePreviewUrl } from 'src/hooks/useCoursePreviewUrl'

const AiCourseReady = props => {
  const { courseData, classes } = props
  const previewUrl = useCoursePreviewUrl(courseData)
  const history = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const collectionId = searchParams.get('collectionId')

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const mobileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: animationDataMobile2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  const handleRedirect = () => {
    if (
      collectionId !== 'undefined' &&
      collectionId !== 'null' &&
      collectionId !== null &&
      collectionId !== undefined &&
      collectionId !== ''
    ) {
      history.push(`/collection/${collectionId}/mini-courses`)
    } else {
      history.push(`/courses`)
    }
    track('ai_course_created_edited', {
      from: 'stepper',
      courseId: courseData.id,
    })
  }
  return (
    <>
      <div
        className={classes.nonMobileViewForFinishScreen}
        style={{ textAlign: 'center' }}
      >
        <Typography variant="h4">
          Your engaging course is ready!
        </Typography>
        <Box m={3}></Box>
        <Typography className={classes.gatewayTooltipStyle}>
          You can enrich it with questions, images, videos, revisions,
          <br />
          customized endings, etc., to make the content uniquely yours.
        </Typography>

        <Typography className={classes.gatewayTooltipStylePc}>
          You can make revisions on your dashboard, which is optimized for
          desktop browsers. Visit your dashboard on a desktop browser to see the
          full functionality.
        </Typography>
        <Box m={2}></Box>

        <CoreButton
          onClick={() => {
            handleRedirect()
          }}
          variant="contained"
          size="large"
          style={{
            width: '250px',
          }}
        >
          Edit Course
        </CoreButton>
        <Box m={2}></Box>
        <div
          className={classes.nonMobileViewForFinishScreen}
          onClick={() => {
            handleRedirect()
          }}
        >
          <Lottie options={defaultOptions} />
        </div>

        <Box m={2}></Box>
      </div>
      <div className={classes.mobileViewForFinishScreen}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '25px',
          }}
        >
          <img src="/assets/tooltip_2x.png" />
          <Box m={1}></Box>
          <Lottie options={mobileLottieOptions} width={300} height={182} />
        </div>
      </div>

      <div className={classes.mobileViewForFinishScreen}>
        <Box m={2}></Box>
        <Divider />
        <Box m={2}></Box>
        <Typography
          variant="h4"
          style={{
            textAlign: 'center',
            fontSize: '20px',
            fontWeight: 600,
            color: '#002E47',
          }}
        >
          Your engaging course <br /> is ready!🎉
        </Typography>
        <Box m={2}></Box>

        {courseData && (
          <div className={classes.carouselViewButton}>
            <CoreButton
              href={previewUrl}
              target="_blank"
              variant="contained"
              size="large"
              onClick={() => {
                track('ai_mobile_check_content', {
                  courseId: courseData.id,
                })
              }}
            >
              Check Content
            </CoreButton>
          </div>
        )}

        <Box m={6}></Box>
        <Typography
          variant="h4"
          style={{
            textAlign: 'center',
            fontSize: '20px',
            fontWeight: 600,
            color: '#002E47',
          }}
        >
          Additional Resources
        </Typography>
        <Box m={2}></Box>
        <Card
          className={classes.redirectCards}
          onClick={() => {
            window.open('https://minicoursegenerator.com/show-cases/', '_blank')
          }}
        >
          <img src="/assets/use-cases.svg" />
          <Box m={1}></Box>
          <div>
            <Typography
              style={{ fontWeight: 600, fontSize: '16px', color: '#002E47' }}
            >
              Show-Cases
            </Typography>
            <Typography
              style={{ fontWeight: 500, fontSize: '12px', color: '#637381' }}
            >
              to check mobile experience <br /> for end-users(audience)
            </Typography>
          </div>
          <Box m={1}></Box>
          <div style={{ flexGrow: 1 }}></div>
          <ArrowForwardIosIcon />
        </Card>

        <Box m={2}></Box>
        <Card
          className={classes.redirectCards}
          onClick={() => {
            window.open('https://minicoursegenerator.com/use-cases/', '_blank')
          }}
        >
          <img src="/assets/show-cases.svg" />
          <Box m={1}></Box>
          <div>
            <Typography
              style={{ fontWeight: 600, fontSize: '16px', color: '#002E47' }}
            >
              Use-Cases
            </Typography>
            <Typography
              style={{ fontWeight: 500, fontSize: '12px', color: '#637381' }}
            >
              to learn best practices of <br /> courses
            </Typography>
          </div>
          <div style={{ flexGrow: 1 }}></div>
          <Box m={1}></Box>
          <ArrowForwardIosIcon />
        </Card>
      </div>
    </>
  )
}

export default withStyles(styles)(AiCourseReady)
